<template>
  <!-- PSG解析結果承認詳細 -->
  <div id="PSGApprovalDetail">
    <div id="container">
      <div class="labelTitle lable">PSG解析 解析結果承認</div>
      <div class="button-area">
        <b-button class="backButton is-primary" v-on:click="back">戻る</b-button>
      </div>
      <div id="item-contens">
        <div class="card-content margin-top">
          <table>
            <tr><th>受付番号</th><td>{{data.receiptNumber}}</td></tr>
            <tr><th>返却希望日</th><td>{{data.returnDate}}</td></tr>
            <tr><th>解析日</th><td>{{data.analysisDay}}</td></tr>
            <tr><th>解析担当者</th><td>{{data.analysisStaffName}}</td></tr>
            <tr><th>解析実施者</th><td>{{data.analysisExecStaffName}}</td></tr>
            <tr><th>検査日</th><td>{{data.inspectionDate}}</td></tr>
            <tr><th>AHI<span class="require"/></th>
            <td><input type="text" class="edit" v-model="data.ahi" maxlength="256" name="AHI" validate="required"/></td>
            </tr>
            <tr><th style="vertical-align:top;">受付備考</th>
              <td><textarea v-model="data.receptionNote" maxlength="256" style="resize:vertical;max-width:100%;height:50px;"></textarea></td>
            </tr>
            <tr><th style="vertical-align:top;">解析結果備考</th>
            <td><textarea v-model="data.memo" maxlength="256" style="resize:vertical;max-width:100%;height:100px;"></textarea></td>
            <tr>
            <tr v-if="data.rejectHistory && data.rejectHistory.length > 0">
              <th>却下理由</th>
              <td colspan="2">
                <table class="reject-reason-table">
                  <tr>
                    <th class="reject-date">日時</th>
                    <th>理由</th>
                  </tr>
                  <tr v-for="reject in data.rejectHistory" :key="reject.value">
                    <td class="reject-date">{{ reject.completionDate }}</td>
                    <td>{{ reject.reason }}</td>
                  </tr>
                </table>
              </td>
            </tr>
            <tr>
              <th style="vertical-align:top;">アップロードファイル名</th>
              <td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;"><span>{{uploadFileName}}<b-button class="clipbordcopy is-primary" @click="clipboardCopy()">コピーする</b-button></span></td>
            </tr>
            <tr>
              <th>解析レポート<br>
                <b-button v-if="fileReplaceStatus.includes(data.status) && !editMode" class="is-primary replaceButton" icon-left="file-replace-outline" @click="replace">差し替え</b-button>
              <div style="width:100px">
                <b-button v-if="fileReplaceStatus.includes(data.status) && editMode" class="is-primary replaceButton" icon-left="cloud-upload-outline " @click="upload">一時保存</b-button>
                <b-button v-if="fileReplaceStatus.includes(data.status) && editMode" class="is-primary replaceButton" style="margin-top:5px;" @click="uploadCancel">キャンセル</b-button>
              </div>
              </th>
              <td>
                <template v-if="editMode">
                  <div class="upload_area uploadArea" @dragenter="dragEnter">
                    ここに添付する解析データをドラッグアンドドロップするか、「ファイルを追加」を押します。
                  </div>
                  <b-modal :active.sync="isUpdateModal" has-modal-card>
                    <div class="modal-card uploadModal" 
                    @dragleave="dragLeave"
                    @drop.prevent="fileDorop"
                    >
                      ここに解析データファイルをドロップします。
                    </div>
                  </b-modal>
                  <b-upload v-model="upButtonFile"  class="file-label" v-on:input="addUploadfile" multiple>
                    <span class="file-cta">
                      <span class="file-label">ファイルを追加</span>
                    </span>
                  </b-upload>
                  <ul class="upfileList">
                    <li v-for="(file,index) of replaceFiles" :key="index">
                      <div v-if="file.ctrl" class="fileNameArea line-through"><b-icon icon="paperclip" />{{file.name}}</div>
                      <div v-else class="fileNameArea"><b-icon icon="paperclip" />{{file.name}}</div>
                      <b-checkbox class="cstmCheckBox deletecheck" v-model="file.ctrl">削除する</b-checkbox>
                    </li>
                  </ul>
                </template>
                <template v-if="!editMode">
                <ul>
                    <li v-for="(file,index) of replaceFiles" :key="index">
                      <template v-if="file.ctrl">
                        <div class="fileName line-through"><b-icon icon="paperclip" />{{file.name}}</div>
                      </template>
                      <template v-else>
                    <template v-if="file.fileAddress"><a v-if="!(status == 'ファイル差替中' && roleId != role.role_psc)" @click="downloadFile(file.fileAddress, file.fileId)"><b-icon icon="paperclip" />{{file.name}}</a></template>
                    <template v-else><b-icon icon="paperclip" />{{file.name}}</template>
                      </template>
                  </li>
                </ul>
                </template>
              </td>
            </tr>
          </table>
        </div>
        <div class="button-area" v-if="status == '承認依頼中'">
          <b-button class="is-primary" @click="approval">承認する</b-button>
          <b-button class="is-primary" @click="dismissalReasonInputModalActive=true">却下する</b-button>
        </div>
        <div class="button-area" v-else-if="status == 'ファイル差替中'">
          <b-button class="is-primary" style="width:20%;" @click="replaceApproval">差し替えファイルを承認する</b-button>
        </div>
      </div>
      <div style="height:5px;" />
      <div class="labelTitle lable">申込内容</div>
      <div id="item-contens">
        <psgRequestDetail v-if="hasDetailData" v-bind:data="detailData" :canDownload="true" :editFlag="true" :hstRequestId="data.hstRequestId" :belongsNote="data.belongsNote" :isInternalPsg="true"/>
      </div>
      <div class="button-area">
        <b-button class="receptionistButton is-primary" @click="save">更新</b-button>
        <b-button class="is-primary" @click="cancelReasonInputModalActive=true">解析をキャンセル</b-button>
        <b-button class="backButton is-primary" @click="back">戻る</b-button>
      </div>
    </div>
    <b-modal :active.sync="dismissalReasonInputModalActive" has-modal-card>
      <reasonInputModal  v-on:setReason="dismissal" v-bind:title="'解析結果却下(却下理由入力)'"></reasonInputModal>
    </b-modal>
    <b-modal :active.sync="cancelReasonInputModalActive" has-modal-card>
      <reasonInputModal  v-on:setReason="cancel" v-bind:title="'解析キャンセル(キャンセル理由入力)'"></reasonInputModal>
    </b-modal>
  </div>
</template>

<script>
import {role} from "@/components/mock/base/const.js";
import psgRequestDetail from "@/components/mock/common/PSGRequestDetail";
import reasonInputModal from "@/components/mock/philips/common/reasonInputModal";
import {UploadType} from "@/components/mock/base/const.js";
import {requestStatus} from "@/components/mock/base/const.js";

export default {
  name: "PSGApprovalDetail",
  methods: {
    getApprovalDetail: function() {
      var excuteApi = this.getPsgResultApprovalDetailPOST;
      var successCallBack = this.getPsgResultApprovalDetailPOSTSuccess;
      var errorCallBack = this.getPsgResultApprovalDetailPOSTError;
      // Web Api Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getPsgResultApprovalDetailPOST: function(client) {
      return client.apis.internalPsg.getPsgResultApprovalDetailPOST({
        body:{ receiptNumber: this.receiptNumber }
      });
    },
    getPsgResultApprovalDetailPOSTSuccess: function(result) {
      this.data = result.obj
      this.version = this.data.version
      this.replaceFiles = this.getCopy(this.data.fileInfo)
      this.uploadFileName = this.data.patientId + "_" + this.data.requestDate + "_" + this.data.hospitalName + "_" + this.data.patientName + "様"
      this.uploadFileName = this.uploadFileName.replace(/[\\/:*?"<>|]/g,'_')
    },
    getPsgResultApprovalDetailPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
      this.back()
    },
    getDetail: function() {
      var excuteApi = this.getAnalysisDetailPOST;
      var successCallBack = this.getAnalysisDetailPOSTSuccess;
      var errorCallBack = this.getAnalysisDetailPOSTError;
      // Web Api Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getAnalysisDetailPOST: function(client) {
      return client.apis.externalAnalysis.getAnalysisDetailPOST({
        body:{receiptNumber:this.receiptNumber}
      });
    },
    getAnalysisDetailPOSTSuccess: function(result) {
      var res = result.obj
      this.upFiles = res.analysisResultFileList
      this.detailData = res.requestDetails
      this.hasDetailData = true
    },
    getAnalysisDetailPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
      this.back()
    },
    back: function() {
      this.$router.push({
        name: "PSGApproval",
        params: { searchConditions: this.searchParams },
      });
    },
    downloadFile: function(fileAddress, fileId){
      var _this = this;
      this.apiCall(
        function(client){
          return client.apis.apiCommon.getDownloadFilePOST({
            body:{
              fileId:fileId,
              fileName:fileAddress,
              updFileInfoFlg:false
            }
          });
        },
        function(result){
          if(result != null && result.status == 200){
            var downloadUrl = result.obj.downloadUrl;
            const a = document.createElement("a");
            document.body.appendChild(a);
            a.href = downloadUrl;
            let targetFile = fileAddress.toLowerCase();
            if(targetFile.endsWith(".pdf")){
                a.target="_blank"
            }
            a.click();
            a.remove();
          } else if(result != null){
            _this.showErrorMessage(result.message);
          } else {
            _this.showErrorMessage("予期しないエラーが発生しました。");
          }
        },
        function(error){
          // エラーメッセージ表示
          _this.showErrorMessage(error);
        }
      );
    },
    save: function() {
      var excuteApi = this.setPsgTempSavePOST;
      var successCallBack = this.setPsgTempSavePOSTSuccess;
      var errorCallBack = this.setPsgTempSavePOSTError;
      // Web Api Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    setPsgTempSavePOST: function(client) {
      var obj = ({
        receiptNumber: this.receiptNumber, // 申込みID
        version: this.version, // バージョン
        viewType:"解析結果承認",
        ahi:this.data.ahi,
        applicationNote:this.detailData.biko, // 依頼内容備考(申送り事項)
        receptionNote: this.data.receptionNote, // 受付備考
        analysisResultNote: this.data.memo,  // 解析結果入力備考
        patientNote:!this.data.hstRequestId || this.detailData.patientBiko ? this.detailData.patientBiko : "", // 患者情報備考
        analysisNote:!this.data.hstRequestId || this.detailData.analysisDataInfo.biko ? this.detailData.analysisDataInfo.biko : "", // 解析データ情報備考
      });
      return client.apis.internalPsg.setPsgTempSavePOST({
        body:obj
      });
    },
    setPsgTempSavePOSTSuccess: function(result) {
      this.showSuccess(result)
      this.hasDetailData = false
      this.getApprovalDetail()
      this.getDetail()
    },
    setPsgTempSavePOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    approval: function() {
      var elements = document.getElementsByClassName("edit");
      var result = this.selfMadeValidation(elements);
      if(result.isError) {
        this.showErrorMessage(result.msg)
        return
      }
      let nameCheckList = this.replaceFiles.filter(val => !val.ctrl)
      if(!this.checkReplaceFileName(nameCheckList)){
        return
      }
      var messsage = "解析内容が正しいことを確認してください。<br>解析結果を承認してよろしいでしょうか？";
      this.$dialog.confirm({
        title: "承認確認",
        message: messsage,
        confirmText:"はい",
        cancelText: "いいえ",
        onConfirm: async() => {
          // 承認する
          var excuteApi = this.setPsgResultApprovePOST;
          var successCallBack = this.setPsgResultApprovePOSTSuccess;
          var errorCallBack = this.setPsgResultApprovePOSTError;
          // Web Api Call
          this.apiCall(excuteApi, successCallBack, errorCallBack);
        }
      });
    },
    setPsgResultApprovePOST: function(client) {
      var obj = {
        receiptNumber: this.receiptNumber,
        analysisMethod: this.analysisMethod,
        version: this.version,
        ahi:this.data.ahi,
        receptionNote:this.data.receptionNote, // 受付備考
        analysisResultNote:this.data.memo, // 解析結果備考
        applicationNote:this.detailData.biko, // 申送り事項
        patientNote:!this.data.hstRequestId || this.detailData.patientBiko ? this.detailData.patientBiko : "", // 患者情報備考
        analysisNote:!this.data.hstRequestId || this.detailData.analysisDataInfo.biko ? this.detailData.analysisDataInfo.biko : "", // 解析データ情報備考
        }
      return client.apis.internalPsg.setPsgResultApprovePOST({
        body:obj
      });
    },
    setPsgResultApprovePOSTSuccess: function(result) {
      this.showSuccess(result)
      this.back()
    },
    setPsgResultApprovePOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
      this.back()
    },
    dismissal: function(reason) {
      // 却下する
      let _this = this;
      // Web Api Call
      this.apiCall(
        function(client){
          return client.apis.internalPsg.setPsgResultApproveRejectePOST({
            body:{
                receiptNumber:_this.data.receiptNumber,
                analysisDeadline:_this.data.analysisDeadline,
                analysisStaffName:_this.data.analysisStaffName,
                reason: reason,
                version: _this.version
              }
          });
        },
        function(result) {
          _this.showSuccess(result);
          _this.back();       
        },
        function(result) {
          _this.showErrorMessage(result);
        }
      );
    },
    cancel: function(reason) {
      // 解析をキャンセルする
      let _this = this;
      // Web Api Call
      this.apiCall(
        function(client){
          return client.apis.internalPsg.setPsgAnalysisResultInspectionCancelPOST({
            body:{
                receiptNumber:_this.data.receiptNumber,
                reason: reason,
                version: _this.version
              }
          });
        },
        function(result) {
          _this.showSuccess(result);
          _this.back();       
        },
        function(result) {
          _this.showErrorMessage(result);
        }
      );
    },
    replace: function(){
      this.editMode = true;
    },
    upload: async function(){
      let nameCheckList = this.replaceFiles.filter(val => !val.ctrl)
      if(nameCheckList.length==0){
        this.showErrorMessage("解析レポートを選択してください。")
        return
      }
      let nameList = nameCheckList.map(item => item['name']);
      for(let i =0; i < nameList.length; i++){
        if(nameList[i].startsWith("/")){
          //フォルダの場合はzip名にしてチェック
          nameList[i] = nameList[i].replace("/", "") + ".zip"
        }
      }
      const setElements = new Set(nameList);
      if (setElements.size !== nameList.length) {
        this.showErrorMessage("解析レポートの重複しているファイルが存在します。")
        return
      }
      var targetFile = this.replaceFiles.filter(val => !val.ctrl && !val.fileId)
      let okSize = await this.checkUploadFileSize(targetFile)
      if(!okSize){
        this.showErrorMessage("2GBを超えるファイルはアップロードできません。")
        return
      }
      
      if(!this.checkReplaceFileName(nameCheckList)){
        return
      }

      //まずはファイルのアップロード
      this.multipleUpload(targetFile ,this.data.receiptNumber, this.UploadType.psg_report, "")
      .then(result => {
        var deleteFile = this.replaceFiles.filter(val => val.ctrl && val.fileId)
        var delFileId = []
        if (deleteFile.length > 0) {
          deleteFile.forEach(ele => {
            delFileId.push(ele.fileId)
          });
        }
        this.replacePsgApplicationFile(delFileId);
      }).catch(error =>{
        this.showErrorMessage("ファイルアップロードに失敗しました。<br>再度実行してください。");
      });
    },
    uploadCancel: function(){
      this.editMode = false;
      this.replaceFiles = this.getCopy(this.data.fileInfo)
    },
    replacePsgApplicationFile: function(delFileId) {
      let _this = this;
      this.apiCall(
        function(client){
          return client.apis.externalPsg.replacePsgApplicationFilePOST({
            body:{
              receiptNumber:_this.data.receiptNumber,
              deleteFileId: delFileId
            }
          });
        },
        function(result){
          _this.showMessage("登録が完了しました。");
          _this.back()
        },
        function(result){
          _this.showErrorMessage(result);
        }
      );
    },
    dragEnter: function() {
      this.isUpdateModal = true;
    },
    dragLeave: function() {
      console.log("dragLeave")
      this.isUpdateModal = false;
    },
    fileDorop: function(event) {
      console.log("fileDorop")
      for(let i =0 ; i < event.dataTransfer.items.length; i++){
        const item = event.dataTransfer.items[i];
        const entry = item.webkitGetAsEntry();
        let path = entry.name;
        if(entry.isDirectory){
          path = entry.fullPath;
        }
        this.replaceFiles.push({ file: entry, path: path , name:path});
      }
      this.isUpdateModal = false;
    },
    addUploadfile: function(){
      for(let upFile of this.upButtonFile){
        this.replaceFiles.push({ file: upFile, path: upFile.name,name:upFile.name })
      }
      this.upButtonFile = [];
    },
    checkReplaceFileName: function(files) {
      for(let uploadItemIfno of files){
        var name = uploadItemIfno.name
        if(name.indexOf(".") != -1 && name.indexOf(this.uploadFileName) == -1){
          this.showErrorMessage("添付したファイルの診察券ID、申込日、医療機関名、患者名が正しくない可能性があります。")
          return false
        }
      }
      return true
    },
    replaceApproval: function() {
      let nameCheckList = this.replaceFiles.filter(val => !val.ctrl)
      if(!this.checkReplaceFileName(nameCheckList)){
        return
      }
      var messsage = "解析内容が正しいことを確認してください。<br>解析結果を承認してよろしいでしょうか？";
      this.$dialog.confirm({
        title: "承認確認",
        message: messsage,
        confirmText:"はい",
        cancelText: "いいえ",
        onConfirm: async() => {
          // 承認する
          var excuteApi = this.setPsgResultReplaceApprovePOST;
          var successCallBack = this.setPsgResultReplaceApprovePOSTSuccess;
          var errorCallBack = this.setPsgResultReplaceApprovePOSTError;
          // Web Api Call
          this.apiCall(excuteApi, successCallBack, errorCallBack);
        }
      });
    },
    setPsgResultReplaceApprovePOST: function(client) {
      return client.apis.internalPsg.setPsgResultReplaceApprovePOST({
        body:{
          receiptNumber: this.receiptNumber
        }
      });
    },
    setPsgResultReplaceApprovePOSTSuccess: function(result) {
      this.showSuccess(result)
      this.back()
    },
    setPsgResultReplaceApprovePOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
      this.back()
    },
    clipboardCopy: function(){
      navigator.clipboard.writeText(this.uploadFileName).then(() => {
        this.showMessage('クリップボードにコピーしました。');
      }).catch(err => {
        this.showMessage('コピーに失敗しました');
        console.log(err);
      });
    }
  },
  data() {
    var item = this.$route.params["item"];
    var receiptNumber = item.receiptNumber;
    var status = item.status;
    var analysisMethod = item.analysisMethod;
    var version = item.version;
    var searchParams = this.$route.params["searchConditions"];
    var detailData = {fileInfo:{}};
    var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    var roleId = "";
    var fileReplaceStatus = [requestStatus.resultSendReady,
    requestStatus.completion,
    requestStatus.salesAppropriation,
    requestStatus.completionAppropriation,
    ]
    if(userInfo){
      var roleId = userInfo.roleId;
    }
    return {
      data: [],
      receiptNumber,
      detailData,
      searchParams,
      upFiles: [],
      status,
      analysisMethod,
      dismissalReasonInputModalActive:false,
      cancelReasonInputModalActive:false,
      hasDetailData: false,
      editMode:false,
      replaceFiles:[],
      UploadType:UploadType,
      isUpdateModal:false,
      upButtonFile:null,
      fileReplaceStatus,
      version,
      uploadFileName:"",
      role: role,
      roleId: roleId,
    };
  },
  filters: {},
  components: {
    psgRequestDetail: psgRequestDetail,
    reasonInputModal:reasonInputModal,
  },
  mounted: function() {
    // 解析結果承認詳細取得
    this.getApprovalDetail()
    // 申込内容取得
    this.getDetail()
  }
};
</script>
<style lang="scss" scoped>
table.flowTable,
table.reject-reason-table {
  border-collapse: collapse;
  table-layout: fixed;
}
table.flowTable tr,
table.flowTable td {
  border: 1px solid;
  padding: 0px;
  vertical-align: middle;
}
table.reject-reason-table th,
table.reject-reason-table tr,
table.reject-reason-table td {
  border: 1px solid;
  padding: 0px;
  vertical-align: middle;
}
table.flowTable td {
  width: 40px;
  text-align: center;
}
table.reject-reason-table td {
  padding-left: 10px;
}
table.reject-reason-table th {
  text-align: center;
}
.reject-reason-table th.reject-date,
.reject-reason-table td.reject-date {
  width: 20% !important;
}
a {
  text-decoration: underline;
}
.uploadModal {
  width: 900px !important;
  height:500px !important;
  display: grid !important;
  place-items: center !important;
}
.clipbordcopy {
  margin-left:3%;
  right: 10px;
  width: 100px;
}
</style>



// WEBPACK FOOTER //
// src/components/mock/philips/psg/PSGApprovalDetail.vue